<template>
  <div >
    <h2 class="type" contenteditable="true" @blur="handleInput" v-text="inputText"></h2>

  </div>
    
</template>

<script>
export default {
    name: 'creature-type',
    props: {
      text: String
    },
    data:function(){
      return{
        inputText:this.text
      }
    },
    methods:{
        handleInput:function(e){
            this.inputText = e.target.innerText;
        }
    }
}
</script>


<style>
    .type:hover{
      background-color: white;
    }
  
    .type{
          font-weight: normal;
          font-style: italic;
          font-size: 12px;
          margin: 0;
          display: table;
  
    }
</style>